import { useMemo } from 'react';
import { Timestamp, where } from 'firebase/firestore';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';
import type { WorkoutSession } from '../types';

export function useTrainerSessions(trainerId?: string) {
  const constraints = useMemo(
    () => [where('trainerId', '==', trainerId)],
    [trainerId],
  );

  const { data: unsorted, error } = useFirestoreCollection<WorkoutSession>(
    trainerId ? 'workoutSessions' : null,
    constraints,
  );

  const sessions = useMemo(
    () =>
      [...unsorted].sort(
        (a, b) =>
          ((b.startedAt as Timestamp)?.toMillis?.() || 0) -
          ((a.startedAt as Timestamp)?.toMillis?.() || 0),
      ),
    [unsorted],
  );

  return { sessions, error };
}
